/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaddleInvoicePdfDTO } from '../models/PaddleInvoicePdfDTO';
import type { PaddleManagementUrlsResponseDTO } from '../models/PaddleManagementUrlsResponseDTO';
import type { PaddleSubscriptionDTO } from '../models/PaddleSubscriptionDTO';
import type { PaddleTransaction } from '../models/PaddleTransaction';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaddleBillingService {
  /**
   * Fetch the temporary management urls for the paddle subscriptions.
   * @param subscriptionId
   * @returns PaddleManagementUrlsResponseDTO The management urls for the paddle subscription
   * @throws ApiError
   */
  public static paddleBillingGetManagementUrls(
    subscriptionId: string
  ): CancelablePromise<PaddleManagementUrlsResponseDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/PaddleBilling/managementUrls/{subscriptionId}',
      path: {
        subscriptionId: subscriptionId,
      },
      errors: {
        400: `Invalid subscription id`,
        401: `Not allowed to access this subscription entity`,
        404: `subscription id cannot be found in system`,
      },
    });
  }

  /**
   * List transactions belonging to the subscription with the given id.
   * @param subscriptionId
   * @returns PaddleTransaction List of transactions
   * @throws ApiError
   */
  public static paddleBillingListTransactions(
    subscriptionId: string
  ): CancelablePromise<Array<PaddleTransaction>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/PaddleBilling/listTransactions/{subscriptionId}',
      path: {
        subscriptionId: subscriptionId,
      },
      errors: {
        400: `Invalid subscription id`,
        401: `Not allowed to access this subscription entity`,
        404: `subscription id cannot be found in system`,
        500: `Error occurred while handling the request to paddle`,
      },
    });
  }

  /**
   * Returns a temporary url to download the invoice pdf of the transaction.
   * Url is valid for roughly 1 hour.
   * @param transactionId Paddle id of the transaction to fetch the pdf for
   * @returns PaddleInvoicePdfDTO Invoice url for the transaction
   * @throws ApiError
   */
  public static paddleBillingGetPdfInvoice(
    transactionId: string
  ): CancelablePromise<PaddleInvoicePdfDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/PaddleBilling/{transactionId}/invoice',
      path: {
        transactionId: transactionId,
      },
      errors: {
        400: `Invalid transaction id`,
        404: `Invoice for transaction cannot be found or does not exist`,
        500: `Error occurred while handling the request to paddle`,
      },
    });
  }

  /**
   * Returns the subscription entity as stored by paddle.
   * @param subscriptionId Valid subscription id
   * @returns PaddleSubscriptionDTO Successfully fetched the subscription data from paddle billing
   * @throws ApiError
   */
  public static paddleBillingGetSubscription(
    subscriptionId: string
  ): CancelablePromise<PaddleSubscriptionDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/PaddleBilling/subscriptions/{subscriptionId}',
      path: {
        subscriptionId: subscriptionId,
      },
      errors: {
        400: `Invalid subscription id`,
        401: `Not allowed to access this subscription entity`,
        404: `subscription id cannot be found in system`,
        500: `Error occurred while handling the request to paddle`,
      },
    });
  }
}
